import React, { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";
import { Rating } from "react-simple-star-rating";

import "swiper/css";
import "swiper/css/pagination";

import "./What_Our_Travelers_Say.css";
import Common_Title from "../../common_component/common_title/Common_Title";
import { getData } from "../../../utils/api";

const testimonials = [
  {
    name: "Priya Mehta",
    location: "Pune Maharashtra",
    image: "/assets/images/holidays/what_our_travellers_say/priya_mehta.png",
    review:
      "Very supportive team. Our Maldives honeymoon was beautifully planned, and the service was excellent throughout the trip.",
  },
  {
    name: "Priya Mehta",
    location: "Pune Maharashtra",
    image: "/assets/images/holidays/what_our_travellers_say/priya_mehta.png",
    review:
      "Very supportive team. Our Maldives honeymoon was beautifully planned, and the service was excellent throughout the trip.",
  },
  {
    name: "Priya Mehta",
    location: "Pune Maharashtra",
    image: "/assets/images/holidays/what_our_travellers_say/priya_mehta.png",
    review:
      "Very supportive team. Our Maldives honeymoon was beautifully planned, and the service was excellent throughout the trip.",
  },
  {
    name: "Priya Mehta",
    location: "Pune Maharashtra",
    image: "/assets/images/holidays/what_our_travellers_say/priya_mehta.png",
    review:
      "Very supportive team. Our Maldives honeymoon was beautifully planned, and the service was excellent throughout the trip.",
  },
  {
    name: "Priya Mehta",
    location: "Pune Maharashtra",
    image: "/assets/images/holidays/what_our_travellers_say/priya_mehta.png",
    review:
      "Very supportive team. Our Maldives honeymoon was beautifully planned, and the service was excellent throughout the trip.",
  },
  {
    name: "Priya Mehta",
    location: "Pune Maharashtra",
    image: "/assets/images/holidays/what_our_travellers_say/priya_mehta.png",
    review:
      "Very supportive team. Our Maldives honeymoon was beautifully planned, and the service was excellent throughout the trip.",
  },
  {
    name: "Priya Mehta",
    location: "Pune Maharashtra",
    image: "/assets/images/holidays/what_our_travellers_say/priya_mehta.png",
    review:
      "Very supportive team. Our Maldives honeymoon was beautifully planned, and the service was excellent throughout the trip.",
  },
  {
    name: "Priya Mehta",
    location: "Pune Maharashtra",
    image: "/assets/images/holidays/what_our_travellers_say/priya_mehta.png",
    review:
      "Very supportive team. Our Maldives honeymoon was beautifully planned, and the service was excellent throughout the trip.",
  },
  {
    name: "Priya Mehta",
    location: "Pune Maharashtra",
    image: "/assets/images/holidays/what_our_travellers_say/priya_mehta.png",
    review:
      "Very supportive team. Our Maldives honeymoon was beautifully planned, and the service was excellent throughout the trip.",
  },
];

const What_Our_Travelers_Say = () => {
  const [rating, setRating] = useState(3);
  const [packages, setPackage] = useState([]);

  const getPackageAll = async () => {
    const response = await getData(`/master/review/`);

    setPackage(response?.data);
  };

  useEffect(() => {
    getPackageAll();
  }, []);
  return (
    <section className="testimonial-section">
      <div className="container">
        <h3 className="testimonial-title">
          <Common_Title
            title={
              <>
                What Our <span>Travelers Say</span>
              </>
            }
          />
        </h3>

        <Swiper
          modules={[Pagination]}
          slidesPerView={3}
          spaceBetween={30}
          pagination={{ clickable: true }}
          autoplay={{ delay: 3000 }}
          breakpoints={{
            0: { slidesPerView: 1 },
            576: { slidesPerView: 2 },
            992: { slidesPerView: 3 },
          }}
        >
          {packages?.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="testimonial-card">
                <div className="quote_wrapper">
                  <img
                    src="/assets/images/footer/comma.png"
                    alt="quote"
                    className="quote-img"
                  />
                </div>

                <div className="testimonial-header">
                  <img src={item?.image} alt={item.name} />

                  <div>
                    <h5>{item?.name}</h5>
                    <span>{item?.city}</span>

                    {/* <div className="rating_div">
                      <Rating initialValue={rating} size={20} />
                      <small className="inner_text">5.0</small>
                    </div> */}

                    {/* <div className="stars">
                      {[...Array(5)].map((_, i) => (
                        <FontAwesomeIcon icon={faStar} key={i} />
                      ))}
                      <small>5.0</small>
                    </div> */}
                  </div>
                </div>

                <p className="testimonial-text">{item?.review}</p>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default What_Our_Travelers_Say;
